"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createApi = require("./createApi");

var _default = function _default() {
  return function (store) {
    return function (next) {
      return function (action) {
        if (!action[_createApi.symbol]) {
          return next(action);
        }

        next({
          type: action.types.request,
          payload: action.payload
        });
        action.request(action.payload).then(function (body) {
          next({
            type: action.types.success,
            payload: {
              request: action.payload,
              body: body,
              meta: {
                receivedAt: Date.now()
              }
            }
          });
        }).catch(function (err) {
          next({
            type: action.types.failure,
            payload: {
              request: action.payload,
              message: err.message,
              data: err.data,
              meta: {
                receivedAt: Date.now()
              }
            }
          });
        });
      };
    };
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-future-middleware/lib/apiMiddleware.js
// module id = 1220
// module chunks = 0